import { render } from "./Maas.vue?vue&type=template&id=3fb43e9c&scoped=true&ts=true"
import script from "./Maas.vue?vue&type=script&lang=ts"
export * from "./Maas.vue?vue&type=script&lang=ts"

import "./Maas.vue?vue&type=style&index=0&id=3fb43e9c&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb43e9c"]])

export default __exports__